<script>
export default {
  /////////////////////////////////////////////////////
  // Data
  /////////////////////////////////////////////////////
  data() {
    return {}
  },
  /////////////////////////////////////////////////////
  // Props
  /////////////////////////////////////////////////////
  props: {
    'step': {
      type: Number,
      default: 0
    },
    'dataLoaded': {
      type: Boolean,
      default: false
    }
  },
  watch: {
    step: function (val) {
      switch (val) {
        case 1:
          $('html, body').animate({ scrollTop: 0 }, 'slow');
          break
        case 2:
          if (window.innerWidth < 1200) {
            $('html, body').animate({ scrollTop: 350 }, 'slow');
          } else {
            $('html, body').animate({ scrollTop: 330 }, 'slow');
          }
          break
        case 3:
          if (window.innerWidth < 1200) {
            $('html, body').animate({ scrollTop: 500 }, 'slow');
          } else {
            $('html, body').animate({ scrollTop: 460 }, 'slow');
          }
          break
      }
    }
  },
  /////////////////////////////////////////////////////
  // Methods
  /////////////////////////////////////////////////////
  methods: {
    nextPage() {
      if (this.step == 3) {
        window.location = '09.html'
      }
    },
    prevPage() {
      if (this.step == 1) {
        window.location = '07.html#2'
      }
    },
    nextStep() {
      this.$emit('next', parseInt(this.step) + 1);
    },
    prevStep() {
      this.$emit('prev', parseInt(this.step) - 1);
    }
  }
}

</script>
